"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function lowercaseFirstLetter(string) {
    if (!string) {
        return string;
    }
    return string[0].toLocaleLowerCase() + string.slice(1, string.length);
}
exports.default = lowercaseFirstLetter;
